<template>
  <div>
    <!-- {{ hide_livePrice }} -->
    <div :class="addClassLive" class="range-container">
      <div
        class="range"
        :id="getRef(trade_data.id)"
        :ref="getRef(trade_data.id)"
      ></div>
      <div
        v-if="hide_live_price"
        :id="trade_data.id ? `live-price${trade_data.id}${ref_append}` : ''"
        class="d-flex flex-column"
      >
        <div class="live-price-icon">
          <v-icon small>mdi-navigation </v-icon>
        </div>
        <div class="adjust-live-price">
          <div class="live-price-txt">₹{{ trade_data.live_price }}</div>
          <!-- <div
            :class="
              parseFloat(trade_data.pl_data) < 0
                ? 'negative-liveprice'
                : 'positive-liveprice'
            "
            class="live-percentage"
          >
            {{ removeNegativeSign(trade_data.pl_data) }} ({{
              trade_data.pl_percent
            }}%)
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["trade_data", "ref_append"],
  data() {
    return {
      // trade_data: this.trade_data,
      target_price_label: this.trade_data.target_price,
      stop_loss: this.trade_data.stop_loss,
      live_price: this.trade_data.live_price,
      range_slide_position: null,
      children: [],
      slides: null,
      firstIndex: -1,
      distance_percentage: null,
      is_sell: this.trade_data.trade_type == "Buy" ? false : true,
      numbers: [],
      hide_live_price: false,
      refs: {},
      stop_loss_arrow: require("@/assets/images/stop_loss_arrow.svg"),
      target_price_arrow: require("@/assets/images/target_price_arrow.svg"),
      ticksLabels: [],
      grey_color: "#cfcfcf",
      red_color: "#EB5757",
      orange_color: "#FAB400",
      green_color: "#359E61",
      green_circle: "#27AE60",
      targetPriceArray: [],
      saved_target_price_position: null,
      dotColoringIndex: null,
    };
  },
  mounted() {
    this.makeArray();
    this.hideLivePrice();
    this.$nextTick(() => {
      this.appendChild();
    });
    // console.log(this.ticksLabels);
  },

  computed: {
    hide_livePrice() {
      if (!this.is_sell) {
        // BUY
        if (
          this.live_price < this.ticksLabels[0] ||
          this.live_price > this.ticksLabels[this.ticksLabels.length - 1] ||
          this.trade_data.status == "Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        // SELL
        if (
          this.live_price > this.ticksLabels[0] ||
          this.live_price < this.ticksLabels[this.ticksLabels.length - 1] ||
          this.trade_data.status == "Closed"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    addClassLive() {
      if (this.hide_livePrice && this.ticksLabels.length == 3) {
        return "reduce-both-margin";
      } else if (this.hide_livePrice) {
        return "reduce-live-margin";
      } else if (this.ticksLabels.length == 3) {
        return "reduce-margin";
      } else return -1;
    },
  },

  methods: {
    removeNegativeSign(value) {
      if (value.slice(0, 1) == "-") {
        return `- ₹${value.slice(1)}`;
      } else {
        return "₹" + value;
      }
    },
    makeArray() {
      if (this.trade_data.target_stop_loss_list.length <= 1) {
        return this.ticksLabels.push(
          this.trade_data.first_stop_loss,
          this.trade_data.entry_price,
          this.trade_data.target_price
        );
      } else {
        let targetprice = [];
        this.trade_data.target_stop_loss_list.forEach((element) => {
          targetprice.push(element.target_price);
        });
        this.targetPriceArray = targetprice;
        return this.ticksLabels.push(
          this.trade_data.first_stop_loss,
          this.trade_data.entry_price,
          ...targetprice
        );
      }
    },

    hideLivePrice() {
      if (!this.is_sell) {
        // BUY
        if (
          this.live_price < this.ticksLabels[0] ||
          this.live_price > this.ticksLabels[this.ticksLabels.length - 1] ||
          this.trade_data.status == "Closed"
        ) {
          this.hide_live_price = false;
        } else {
          this.hide_live_price = true;
        }
      } else {
        // SELL
        if (
          this.live_price > this.ticksLabels[0] ||
          this.live_price < this.ticksLabels[this.ticksLabels.length - 1] ||
          this.trade_data.status == "Closed"
        ) {
          this.hide_live_price = false;
        } else {
          this.hide_live_price = true;
        }
      }
    },

    getRef(id) {
      return `parentElements${id}${this.ref_append}`;
    },
    circleStyles(childElement) {
      childElement.style.position = "absolute";
      childElement.style.height = "10px";
      childElement.style.width = "10px";
      childElement.style.borderRadius = "50%";
      childElement.style.backgroundColor = this.grey_color;
      childElement.style.transform = "translateY(-25%)";
    },
    trailLineStyles(child_range) {
      child_range.style.position = "absolute";
      child_range.style.height = "3px";
      child_range.style.borderRadius = "0%";
    },
    async appendChild() {
      // let parentElement = this.$refs[this.getRef(this.trade_data.id)];
      let parentElement = document.querySelector(
        `#${this.getRef(this.trade_data.id)}`
      );

      let entry_price = "";
      let target_price_position = "";
      let range_slide_position = "";
      // let distance_percentage = "";

      // let last_entry_price = "";
      for (let i = 0; i < this.ticksLabels.length; i++) {
        this.dotColoringIndex = i;
        const childElement = document.createElement("div");

        // childElement.classList.add(`maindiv${i}`);
        childElement.setAttribute("id", `maindiv${this.trade_data.id}${i}`);

        let leftPosition = 100 / (this.ticksLabels.length - 1) + "%";

        // if (i == 0 || i == this.ticksLabels.length) {
        //   console.log(i);
        // } else {
        //   childElement.style.left = Number(leftPosition.slice(0, -1)) * i + "%";
        //   range_slide_position = Number(leftPosition.slice(0, -1)) * i + "%";
        // }

        if (i != 0 || i != this.ticksLabels.length) {
          childElement.style.left = Number(leftPosition.slice(0, -1)) * i + "%";
          range_slide_position = Number(leftPosition.slice(0, -1)) * i + "%";
        }

        // Apply styles for circle
        this.circleStyles(childElement, leftPosition);

        if (i == 1) {
          entry_price = leftPosition;
        }

        if (this.targetPriceArray.length > 0) {
          if (!this.is_sell) {
            if (this.live_price >= this.targetPriceArray[i - 2]) {
              target_price_position =
                Number(range_slide_position.slice(0, -1)) + "%";
              this.target_price_label = this.targetPriceArray[i - 2 + 1];
              // this.stop_loss = this.ticksLabels[i - 1];
            }
          } else {
            if (this.live_price <= this.targetPriceArray[i - 2]) {
              target_price_position =
                Number(range_slide_position.slice(0, -1)) + "%";
              // console.log("IF IF", this.live_price, this.targetPriceArray[i - 2]);
              this.target_price_label = this.targetPriceArray[i - 2 + 1];
              // this.stop_loss = this.ticksLabels[i - 1];
            }
          }

          // if (this.live_price > this.targetPriceArray[i - 2]) {
          //   target_price_position =
          //     Number(range_slide_position.slice(0, -1)) + "%";

          //   this.target_price_label = this.targetPriceArray[i - 2];
          // }
        } else {
          if (this.ticksLabels[i] == this.target_price_label) {
            target_price_position = range_slide_position;
          }
        }

        // if (this.ticksLabels[i] == this.target_price_label) {
        //   target_price_position = range_slide_position;
        // }
        parentElement?.appendChild(childElement);

        // make slides colour trail line  👇
        const child_range = document.createElement("div");

        // Apply styles for trail line
        child_range.classList.add(`range-slide${i}`);
        child_range.setAttribute("id", `range-slide${this.trade_data.id}${i}`);

        this.trailLineStyles(child_range);
        parentElement?.appendChild(child_range);

        // make label 👇
        const label_child_element = document.createElement("div");
        label_child_element.classList.add(`label${this.trade_data.id}${i}`);

        label_child_element.innerHTML = `<div>
         <div class="line-labels-txt"> ${
           i == 0
             ? `${this.ticksLabels.length == 3 ? "Stop Loss" : "SL"}`
             : i == 1
             ? `${this.ticksLabels.length == 3 ? "Entry" : "EP"}`
             : `${this.ticksLabels.length == 3 ? "Target" : "TP"}`
         } ${
          i == 0 || i == 1 ? "" : this.ticksLabels.length == 3 ? "" : i - 1
        } </div>
         <div class="trailing-labels-text">₹${this.ticksLabels[i]}</div>
         <div style="${this.ticksLabels.length == 3 ? "display:none" : ""}"
         " class="${
           this.ticksLabels[i] == this.stop_loss
             ? "trail-line-currentSL"
             : this.ticksLabels[i] == this.target_price_label
             ? "trail-line-currentTP"
             : ""
         }"> ${
          this.ticksLabels[i] == this.stop_loss
            ? `${
                this.trade_data.status == "Closed" ? "Stop Loss" : "Current SL"
              }`
            : this.ticksLabels[i] == this.target_price_label
            ? `${this.trade_data.status == "Closed" ? "Target" : "Current TP"}`
            : ""
        }

         </div>
           <div>
             <img
             style="${this.ticksLabels.length == 3 ? "display:none" : ""}"
             class="${
               this.ticksLabels[i] == this.stop_loss
                 ? "stop-loss-arrow"
                 : "hide-stoploss-arrow"
             }" src="${this.stop_loss_arrow}" />
             <img
             style="${this.ticksLabels.length == 3 ? "display:none" : ""}"
             class="${
               this.ticksLabels[i] == this.target_price_label
                 ? "target-price-arrow"
                 : "hide-targetprice-arrow"
             }" src="${this.target_price_arrow}" />
           </div>
        </div>`;

        // add 70px-width when upcoming
        // let last_label_child = document.querySelector(
        //   `.label${this.trade_data.id}${i}`
        // );
        // console.log(last_label_child);
        // let currentTP = last_label_child.querySelector(".trail-line-currentTP");
        // console.log(currentTP);
        // currentTP.style.backgroundColor = "red";

        // if (this.trade_data.status == "Inactive") {
        //   currentTP.style.width = "70px";
        // }

        /** Apply styles for @target_circle green colour
         */
        if (this.targetPriceArray.length > 0) {
          if (!this.is_sell) {
            if (this.live_price >= this.targetPriceArray[i - 2]) {
              for (let index = 1; index <= this.dotColoringIndex; index++) {
                // console.log(index);
                // let main_cirlce_next = document.querySelector(
                //   `#maindiv${this.trade_data.id}${index + 1}`
                // );
                // if (main_cirlce_next) {
                //   index++;
                //   console.log("next main circle exists", index);
                // }
                // console.log(
                //   "INSIDE FOR LOOP: index->",
                //   index,
                //   i,
                //   this.dotColoringIndex
                // );
                let main_cirlce = document.querySelector(
                  `#maindiv${this.trade_data.id}${index}`
                );
                if (!this.is_sell) {
                  if (
                    this.live_price >= this.targetPriceArray[index - 2] &&
                    this.trade_data.status != "Inactive"
                  ) {
                    main_cirlce.style.backgroundColor = this.green_circle;
                  }
                } else {
                  if (
                    this.live_price <= this.targetPriceArray[index - 2] &&
                    this.trade_data.status != "Inactive"
                  ) {
                    main_cirlce.style.backgroundColor = this.green_circle;
                  }
                }
              }
            }
          } else {
            if (this.live_price <= this.targetPriceArray[i - 2]) {
              for (let index = 1; index <= this.dotColoringIndex; index++) {
                // console.log(index);
                // let main_cirlce_next = document.querySelector(
                //   `#maindiv${this.trade_data.id}${index + 1}`
                // );
                // if (main_cirlce_next) {
                //   index++;
                //   console.log("next main circle exists", index);
                // }
                let main_cirlce = document.querySelector(
                  `#maindiv${this.trade_data.id}${index}`
                );
                if (!this.is_sell) {
                  if (
                    this.live_price >= this.targetPriceArray[index - 2] &&
                    this.trade_data.status != "Inactive"
                  ) {
                    main_cirlce.style.backgroundColor = this.green_circle;
                  }
                } else {
                  if (
                    this.live_price <= this.targetPriceArray[index - 2] &&
                    this.trade_data.status != "Inactive"
                  ) {
                    main_cirlce.style.backgroundColor = this.green_circle;
                  }
                }
              }
            }
          }
        } else {
          if (this.ticksLabels[i] == this.target_price_label) {
            for (let index = 1; index <= i; index++) {
              let main_cirlce = document.querySelector(
                `#maindiv${this.trade_data.id}${index}`
              );
              if (!this.is_sell) {
                if (
                  this.live_price >= this.ticksLabels[2] &&
                  this.trade_data.status != "Inactive"
                ) {
                  main_cirlce.style.backgroundColor = this.green_circle;
                }
              } else {
                if (
                  this.live_price <= this.ticksLabels[2] &&
                  this.trade_data.status != "Inactive"
                ) {
                  main_cirlce.style.backgroundColor = this.green_circle;
                }
              }
            }
          }
        }

        /**  @add width of @TP_width when ticklabels is greater than 3 👇*/
        // let line_label_text = document.querySelector(".line-labels-txt");

        // if (this.ticksLabels.length == 3) {
        //   line_label_text.style.width = "initial";
        //   console.log(line_label_text.width);
        // }
        // Apply styles for label
        label_child_element.style.position = "absolute";
        label_child_element.style.bottom = "8px";
        // if (i == 0 || i == this.ticksLabels.length) {
        //   console.log(i);
        // } else {
        //   label_child_element.style.left =
        //     Number(leftPosition.slice(0, -1)) * i + "%";
        // }

        if (i != 0 || i != this.ticksLabels.length) {
          label_child_element.style.left =
            Number(leftPosition.slice(0, -1)) * i + "%";
        }
        parentElement?.appendChild(label_child_element);
      }

      /** make @main_circle with div 👇*/

      this.$nextTick(() => {
        let first_child = document.querySelector(
          `#maindiv${this.trade_data.id}0`
        );
        first_child.style.left = "0%";
        let lastChild = document.querySelector(
          `#maindiv${this.trade_data.id}${this.ticksLabels.length - 1}`
        );
        lastChild.style.left = "100%";
        const last_label_child = document.querySelector(
          `.label${this.trade_data.id}${this.ticksLabels.length - 1}`
        );
        last_label_child.style.left = "96.6%";
        if (this.$vuetify.breakpoint.xsOnly) {
          lastChild.style.left = "97%";
          last_label_child.style.left = "93.2%";

          // add -20px of current -p of when last label👇
          let last_trailline_currentTP = last_label_child.querySelector(
            ".trail-line-currentTP"
          );
          last_trailline_currentTP.left = "-20px";

          // if (this.trade_data.status == "Inactive") {
          //   last_trailline_currentTP.style.width = "70px";
          // }
          // console.log(last_trailline_currentTP.left);
        }
      });

      // for range slide colour div class
      this.colourRangeSlide(entry_price, target_price_position);

      // for colour circle

      // });
      // for live price
      this.livePrice(entry_price);

      // else {
      //   last_trailline_currentTP.style.width = "60px";
      // }
    },

    livePrice(entry_price) {
      entry_price = Math.floor(entry_price.slice(0, -1));
      let live_price_element = document.querySelector(
        `#live-price${this.trade_data.id}${this.ref_append}`
      );
      if (live_price_element) {
        live_price_element.style.position = "absolute";
        live_price_element.style.display = "inline";
        live_price_element.style.top = "10px";
      }
      let main_circle_div;

      if (this.targetPriceArray.length > 0) {
        //
        if (!this.is_sell) {
          // BUY
          for (let index = 0; index < this.ticksLabels.length; index++) {
            // console.log("LIVE PRICE", this.live_price);
            // if (Number(this.live_price) == this.ticksLabels[0]) {
            //   live_price_element.style.left = "0%";
            //   return;
            // }
            if (Number(this.live_price) <= this.ticksLabels[index]) {
              // console.log(this.ticksLabels[index]);
              this.distance_percentage =
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index] - this.ticksLabels[index - 1])) *
                100;
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              let calculate_live_percetage =
                main_circle_div +
                this.distance_percentage * (entry_price / 100);

              live_price_element.style.left =
                (calculate_live_percetage < 0 ? 0 : calculate_live_percetage) +
                "%";
              // live_price_element.style.left = calculate_live_percetage;
              return;
            }

            if (Number(this.live_price) > this.ticksLabels[index]) {
              this.distance_percentage = Math.abs(
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index - 1] - this.ticksLabels[index])) *
                  100
              );
              // console.log(this.ticksLabels[index]);
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              // console.log(this.live_price - this.ticksLabels[index]);
              // console.log(main_circle_div);
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              // let calculate_live_percetage =
              //   main_circle_div + this.distance_percentage * (entry_price / 100);

              let calculate_live_percetage =
                (entry_price / 100) * this.distance_percentage;

              live_price_element.style.left =
                Math.abs(main_circle_div + calculate_live_percetage) + "%";

              continue;
            }
          }
        } else {
          // SELL
          for (let index = 0; index < this.ticksLabels.length; index++) {
            // if (Number(this.live_price) == this.ticksLabels[0]) {
            //   live_price_element.style.left = "0%";
            //   return;
            // }
            if (Number(this.live_price) >= this.ticksLabels[index]) {
              // console.log(this.ticksLabels[index]);
              this.distance_percentage =
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index] - this.ticksLabels[index - 1])) *
                100;
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              let calculate_live_percetage =
                main_circle_div +
                this.distance_percentage * (entry_price / 100);

              live_price_element.style.left = calculate_live_percetage + "%";
              return;
            }

            if (Number(this.live_price) < this.ticksLabels[index]) {
              this.distance_percentage = Math.abs(
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index - 1] - this.ticksLabels[index])) *
                  100
              );
              // console.log(this.ticksLabels[index]);
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              // console.log(this.live_price - this.ticksLabels[index]);
              // console.log(main_circle_div);
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              // let calculate_live_percetage =
              //   main_circle_div + this.distance_percentage * (entry_price / 100);

              let calculate_live_percetage =
                (entry_price / 100) * this.distance_percentage;
              // console.log((entry_price / 100) * this.distance_percentage);

              // console.log(
              //   "main circle div",
              //   main_circle_div,
              //   "calculate_live_percetage",
              //   calculate_live_percetage
              // );

              live_price_element.style.left =
                Math.abs(main_circle_div + calculate_live_percetage) + "%";

              continue;
            }
          }
        }
      } else {
        if (!this.is_sell) {
          // BUY
          for (let index = 0; index < this.ticksLabels.length; index++) {
            // if (Number(this.live_price) == this.ticksLabels[0]) {
            //   live_price_element.style.left = "0%";
            //   return;
            // }
            if (Number(this.live_price) <= this.ticksLabels[index]) {
              // console.log(this.ticksLabels[index]);
              this.distance_percentage =
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index] - this.ticksLabels[index - 1])) *
                100;
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              let calculate_live_percetage =
                main_circle_div +
                this.distance_percentage * (entry_price / 100) -
                0.8;

              live_price_element.style.left =
                (calculate_live_percetage < 0 ? 0 : calculate_live_percetage) +
                "%";
              continue;
            }

            if (Number(this.live_price) > this.ticksLabels[index]) {
              this.distance_percentage = Math.abs(
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index - 1] - this.ticksLabels[index])) *
                  100
              );
              // console.log(this.ticksLabels[index]);
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              // console.log(this.live_price - this.ticksLabels[index]);
              // console.log(main_circle_div);
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              // let calculate_live_percetage =
              //   main_circle_div + this.distance_percentage * (entry_price / 100);

              let calculate_live_percetage =
                (entry_price / 100) * this.distance_percentage;

              live_price_element.style.left =
                Math.abs(main_circle_div + calculate_live_percetage) + "%";

              continue;
            }
          }
        } else {
          // SELL
          for (let index = 0; index < this.ticksLabels.length; index++) {
            // if (Number(this.live_price) == this.ticksLabels[0]) {
            //   live_price_element.style.left = "0%";
            //   return;
            // }
            if (Number(this.live_price) >= this.ticksLabels[index]) {
              // console.log(this.ticksLabels[index]);
              this.distance_percentage =
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index] - this.ticksLabels[index - 1])) *
                100;
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              let calculate_live_percetage =
                main_circle_div +
                this.distance_percentage * (entry_price / 100) -
                0.8;

              live_price_element.style.left = calculate_live_percetage + "%";
              continue;
            }

            if (Number(this.live_price) < this.ticksLabels[index]) {
              this.distance_percentage = Math.abs(
                ((this.live_price - this.ticksLabels[index - 1]) /
                  (this.ticksLabels[index - 1] - this.ticksLabels[index])) *
                  100
              );
              // console.log(this.ticksLabels[index]);
              main_circle_div = document.querySelector(
                `#maindiv${this.trade_data.id}${index - 1}`
              )?.style.left; //div ka value
              // console.log(this.live_price - this.ticksLabels[index]);
              // console.log(main_circle_div);
              main_circle_div = Math.floor(main_circle_div?.slice(0, -1));

              // let calculate_live_percetage =
              //   main_circle_div + this.distance_percentage * (entry_price / 100);

              let calculate_live_percetage =
                (entry_price / 100) * this.distance_percentage;
              // console.log((entry_price / 100) * this.distance_percentage);

              // console.log(
              //   "main circle div",
              //   main_circle_div,
              //   "calculate_live_percetage",
              //   calculate_live_percetage
              // );

              live_price_element.style.left =
                Math.abs(main_circle_div + calculate_live_percetage) + "%";

              continue;
            }
          }
        }
      }

      // return -1;
    },
    //function of live slide colour
    changeLiveSlideColour(entry_price) {
      if (this.trade_data.status != "Inactive") {
        // let range_first_child = document.querySelector(".range-slide0");
        let range_first_child = document.querySelector(
          `#range-slide${this.trade_data.id}0`
        );
        range_first_child.style.width = entry_price;
        range_first_child.style.backgroundColor = this.red_color;
        //    change bg-color of circle when live price lower than entry lrice
        let firstlive_main_cirlce = document.querySelector(
          `#maindiv${this.trade_data.id}0`
        );
        firstlive_main_cirlce.style.backgroundColor = this.red_color;
      }
      // let secondlive_main_cirlce = document.querySelector(
      //   `#maindiv${this.trade_data.id}1`
      // );
      // secondlive_main_cirlce.style.zIndex = 1;
      // secondlive_main_cirlce.style.backgroundColor = "#FAB400";
    },
    colourRangeSlide(entry_price, target_price_position) {
      let secondlive_main_cirlce = document.querySelector(
        `#maindiv${this.trade_data.id}1`
      );
      secondlive_main_cirlce.style.zIndex = 1;
      secondlive_main_cirlce.style.backgroundColor = this.orange_color;
      if (this.trade_data.status != "Inactive") {
        // give width of range-slide when live price lower than entry price

        // if (this.live_price > this.ticksLabels[1] && this.is_sell) {
        //   this.changeLiveSlideColour(entry_price);
        // }

        // if(this.live_price < this.ticksLabels[0])

        if (!this.is_sell) {
          // BUY
          if (this.live_price <= this.ticksLabels[0]) {
            this.changeLiveSlideColour(entry_price);
          }
          if (this.live_price >= this.ticksLabels[2]) {
            //green colour change when live price is greater than EP
            let entry_price_element = document.querySelector(
              `#range-slide${this.trade_data.id}1`
            );
            entry_price_element.style.left = entry_price;
            // console.log(
            //   "green lineq",
            //   `${this.trade_data.security_symbol} ${Number(
            //     target_price_position.slice(0, -1)
            //   )}`
            // );
            entry_price_element.style.width = `${Number(
              target_price_position.slice(0, -1) -
                Number(entry_price.slice(0, -1))
            )}%`;
            entry_price_element.style.backgroundColor = this.green_color;
          }
        } else {
          // SELL
          if (this.live_price >= this.ticksLabels[0]) {
            this.changeLiveSlideColour(entry_price);
          }
          if (this.live_price <= this.ticksLabels[2]) {
            //green colour change when live price is greater than EP
            let entry_price_element = document.querySelector(
              `#range-slide${this.trade_data.id}1`
            );
            entry_price_element.style.left = entry_price;
            // console.log(
            //   "green lineq",
            //   `${this.trade_data.security_symbol} ${Number(
            //     target_price_position.slice(0, -1)
            //   )}`
            // );
            entry_price_element.style.width = `${Number(
              target_price_position.slice(0, -1) -
                Number(entry_price.slice(0, -1))
            )}%`;
            entry_price_element.style.backgroundColor = this.green_color;
          }
        }
        // if (this.live_price <= this.ticksLabels[0]) {
        //   this.changeLiveSlideColour(entry_price);
        // }

        /**  for @green_color_range slide👇 */
        // let entry_price_element = document.querySelector(".range-slide1");
        //
      }
    },
  },
};
</script>
<style>
.trailing-labels-text {
  /* font-size: 0.3rem; */
}
.stop-loss-arrow {
  position: absolute;
  bottom: 38px;
  left: 8px;
}
.target-price-arrow {
  position: absolute;
  bottom: 38px;
  left: 8px;
}
.hide-stoploss-arrow {
  display: none;
}
.hide-targetprice-arrow {
  display: none;
}
.my-trailline-image {
}
.line-labels-txt {
  color: #858585;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  /* width: 53px; */
}
.line-labels-txt + div {
  color: #0a0a0a;
  font-family: Avenir;
  font-size: 0.75rem;
  /* font-style: normal; */
  /* font-weight: 700; */
  line-height: normal;
}
.trail-line-currentSL {
  position: absolute;
  width: 60px;
  right: 0px;
  left: -18px;
  bottom: 48px;
  padding: 0.25rem;
  gap: 0.625rem;
  border-radius: 0.25rem;
  background: var(--Red, #eb5757);
  color: #fff;
  text-align: center;
  font-family: Avenir;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.trail-line-currentTP {
  position: absolute;
  width: 60px;
  right: 0px;
  left: -18px;
  bottom: 48px;
  padding: 0.25rem;
  gap: 0.625rem;
  border-radius: 0.25rem;
  background: var(--Green-2, #27ae60);
  color: #fff;
  text-align: center;
  font-family: Avenir;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

@media only screen and (max-width: 768px) {
  .line-labels-txt + div {
    font-size: 0.6rem;
  }
}
</style>
<style lang="scss" scoped>
.reduce-live-margin {
  margin-bottom: 16px !important;
}
.reduce-margin {
  margin-top: 40px !important;
  // margin-bottom: 16px !important;
}
.reduce-both-margin {
  margin-top: 40px !important;
  margin-bottom: 16px !important;
}
.adjust-live-price {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-left: -24px;
}
.live-price-txt {
  color: #333;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  // margin-left: -10px;
}
.live-percentage {
  // color: var(--Red, #eb5757);
  font-family: Avenir;
  font-size: 0.69rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.live-price-icon {
  margin-right: 10.8px;
}
.live-price {
  display: inline;
  position: absolute;
  top: 10px;
}
.range-container {
  // padding-top: 40px;
  margin-top: 70px;
  margin-bottom: 50px;
  width: 99%;
  height: 3px;
  border-radius: 4px;
  background-color: #cfcfcf;
  position: relative;
}
.labels > div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.range-slide {
}
.positive-liveprice {
  color: rgb(51, 193, 110);
}
.negative-liveprice {
  color: #eb5757;
}
@media only screen and (max-width: 768px) {
  .reduce-live-margin {
    margin-bottom: 0px !important;
  }
  .reduce-margin {
    margin-top: 40px !important;
    // margin-bottom: 16px !important;
  }
  .reduce-both-margin {
    margin-top: 40px !important;
    margin-bottom: 0px !important;
  }
}
</style>
